'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebFont = require('webfontloader');

exports.onInitialClientRender = function (a, options) {
	options = (0, _extends3.default)({}, options);
	delete options.plugins;
	WebFont.load(options);
};
//# sourceMappingURL=gatsby-browser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-web-font-loader/gatsby-browser.js
// module id = 677
// module chunks = 231608221292675